import nominations from '@/api/projectNominations'

const actions = {
  createProjectNominations ({ commit, state }, { projectID, data }) {
    return new Promise((resolve, reject) => {
      nominations.createProjectNominations(projectID, data).then((response) => {
        const success = response.data.result.success
        resolve(success)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default {
  actions
}
